import { useNavigate } from 'react-router-dom';
import { PresentationChartLineIcon } from '@heroicons/react/24/solid';
import BottomNav from '../components/mobile/BottomNav';
import { useState, useEffect } from 'react';
import { useVideoSections } from '../config/videoSections';
import { useTranslations } from '../hooks/useTranslations';

function VideoLessons() {
  const navigate = useNavigate();
  const [userData, setUserData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const { t } = useTranslations();
  const videoSections = useVideoSections();

  // Получаем данные пользователя при загрузке
  useEffect(() => {
    const fetchUserData = async () => {
      const token = localStorage.getItem('token');
      if (!token) {
        setIsLoading(false);
        return;
      }

      try {
        const response = await fetch("https://api.maxprofitacademy.com/user", {
          method: "GET",
          headers: {
            "token": JSON.parse(token)
          }
        });

        const data = await response.json();
        if (data.status === 200) {
          setUserData(data.data);
        }
      } catch (error) {
        console.error('Error fetching user data:', error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchUserData();
  }, []);

  // Получаем доступные секции для пользователя
  const accessibleSections = videoSections.filter(section => {
    if (!userData || !userData.course) return false;
    const userCourse = userData.course.toUpperCase();
    return section.allowedCourses.includes(userCourse);
  });

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-primary"></div>
        <span className="ml-3 text-gray-600">{t('videoLessons.loading')}</span>
      </div>
    );
  }

  // Если у пользователя нет доступа к видеоурокам
  if (!userData || !userData.course || accessibleSections.length === 0) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center">
        <div className="bg-primary/10 mt-10 p-6 rounded-2xl mb-6 flex items-center justify-center">
          <PresentationChartLineIcon className="w-12 h-12 text-primary mr-4" />
          <span className="text-xl font-semibold text-gray-700">
            {t('videoLessons.noAccessTitle')}
          </span>
        </div>
        <BottomNav />
      </div>
    );
  }

  return (
    <div className="min-h-screen pb-20">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        {accessibleSections.map((section) => {
          const Icon = section.Icon;
          return (
            <div
              key={section.id}
              className="relative overflow-hidden rounded-2xl bg-primary shadow-lg cursor-pointer transition-all duration-300 hover:-translate-y-1 hover:shadow-xl p-6 flex flex-col items-center"
              onClick={() => navigate(section.path)}
            >
              <div className="bg-black/10 rounded-xl p-4 mb-4">
                <Icon className="h-10 w-10 text-black" />
              </div>
              <h3 className="text-xl font-bold mb-2 text-center text-black">{section.title}</h3>
              <div className="text-sm text-black/80">{section.lessons} {t('videoLessons.lessons')}</div>
              {section.description && (
                <div className="text-xs text-black/60 mt-2 text-center">{section.description}</div>
              )}
            </div>
          );
        })}
      </div>
      <BottomNav />
    </div>
  );
}

export default VideoLessons; 